'use strict';

const deepAssign = require('../deep-assign'),
	nodeStyleFromAttributes = require('./node-style-from-attributes'),
	applyFontMultiplierToNodeTheme = require('./apply-font-multiplier-to-node-theme');
module.exports = function applyIdeaAttributesToNodeTheme(idea, nodeTheme) {
	if (!nodeTheme  || !idea || !idea.attr || !idea.attr.style) {
		return nodeTheme;
	}
	const nodeStyle = nodeStyleFromAttributes(idea, nodeTheme),
		result = deepAssign({}, nodeTheme, nodeStyle);
	applyFontMultiplierToNodeTheme(idea, result);
	return result;
};
